import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export enum ActionTypes {
  REDIRECT = 'redirect'
}

export class SnackBarMessage {
  constructor(
    public message: string,
    public actionLabel?: string,
    public actionType?: ActionTypes,
    public actionMeta?: unknown[]
  ) {}
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  messageSubject: Subject<SnackBarMessage> = new Subject<SnackBarMessage>();

  setMessage(message: string, actionLabel?: string, actionType?: ActionTypes, actionMeta?: unknown[]) {
    this.messageSubject.next({ message, actionLabel, actionType, actionMeta });
  }

  getMessageSubjectAsObservable(): Observable<SnackBarMessage> {
    return this.messageSubject.asObservable();
  }
}
